// This file is for helpers that relate to any url helpers within the application

import * as R from 'ramda';

const replaceHash = R.replace(/%23/g, '#');
const replaceAmp = R.replace(/%26/g, '&');
const replacePct = R.replace(/%25/g, '%');
const replacePctnl = R.replace(/%/g, '%25');
const replaceSlash = R.replace(/%2F/g, '/');
const replacePlus = R.replace(/%2B/g, '+');
const replaceComma = R.replace(/%2C/g, ',');
const replaceSpace = R.replace(/%20/g, ' ');

// have to use our own decodeURI function
// because react router only decodes half the special characters, app crashes with native decodeURI
export const decodeURI = R.compose(
  replacePct,
  replaceHash,
  replaceAmp,
  replaceSlash,
  replacePlus,
  replaceComma,
  replaceSpace
);

// decodeURI that also handles % signs correctly
export const decodeURIWithPct = R.compose(
  replacePct,
  replacePctnl,
  replaceHash,
  replaceAmp,
  replaceSlash,
  replacePlus,
  replaceComma,
  replaceSpace
);

// react-router will cause issues when attempting to push a selection with a %
// https://github.com/ReactTraining/history/issues/505
export const getSelectionURI = R.compose(
  encodeURIComponent,
  R.trim,
  R.replace(/10%E/g, '10%25E'),
  R.replace(/%/g, '%25'),
  // R.ifElse(R.has('nameShort'), R.prop('nameShort'), R.prop('carrierName'))
  R.cond([
    [R.has('nameShort'), R.prop('nameShort')],
    [R.has('carrierName'), R.prop('carrierName')],
    [R.T, val => val],
  ])
);
